import React from 'react';
import _validator from 'modules/validator';
import _StudentService from '../../modules/StudentService';
import _notification from 'modules/notification';
import { useState, useEffect } from "react";

const Challan = (props) => {
    const [personalData, setPersonalData] = useState([]);
    const [bankDetails, setBankDetails] = useState([]);
    const [note, setNote] = useState("");
    const [reservationDetails, setReservationDetails] = useState([]);


    useEffect(() => {
        if (props.data) {
            setPersonalData(props.data);
            setBankDetails(props.bankDetails);
            setNote(props.note);
            setReservationDetails(props.reservationDetails);
        }
    }, []);


    return (
        <>
            <table className="challanTable" style={{ marginLeft: "1%", marginTop: "2%" }}>
                <colgroup>
                    <col style={{ width: "159.005682px", height: '15px' }} />
                    <col style={{ width: "291.005682px", height: '15px' }} />
                </colgroup>
                <thead>
                    <tr style={{ height: '5px' }}>
                      
                        <th className='_12px pl5' style={{marginLeft:"5px"}}>Cash Only
                            <div className='displayInGrid'>केवळ रोख रक्कम</div>
                        </th>
                        
                        <th className="challanTable-centertext _12px">{props.copyName}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="challanTable-centertext" colSpan="2">

                            <table style={{ width: '100%' }}>
                                <tbody>
                                    <tr>
                                        <td style={{ verticalAlign: 'Middle', borderStyle: 'none' }}>
                                            <img height="45px" width="90px" style={{objectFit: 'contain'}} src={bankDetails.Bank_Image_Path} />
                                        </td>
                                        <td style={{ borderStyle: 'none' }}>{bankDetails.Bank_Name_Marathi}
                                            <br></br>{bankDetails.Bank_Name_English}
                                            <br></br>{bankDetails.Account_Name_Marathi}
                                        </td>
                                        <td style={{ verticalAlign: 'Middle', borderStyle: 'none' }}>
                                            <img height="45px" width="90px" style={{objectFit: 'contain'}} src={bankDetails.Bank_Logo_Path} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td className="challanTable-centertext" colSpan="2">{bankDetails.Account_Name_English}</td>
                    </tr>
                    <tr>
                        <td className="challanTable-centertext italicNormal _12px" colSpan="2">{bankDetails.Subtext}</td>
                    </tr>
                    <tr>
                    
                        <td className="_normal">Branch Name
                            <div className='displayInGrid'>शाखेचे नाव</div>
                        </td>
                   
                        <td className=""></td>
                    </tr>
                    <tr>
                        <td className="_normal">Branch SOL ID
                        <div className='displayInGrid'>शाखा आयडी</div>
                        </td>
                        <td className="_normal"></td>
                    </tr>
                    <tr>
                    <div className='displayInGrid'>
                            <td className="_normal challanBorderTRB">A/c. No.
                                <div>खाते क्रमांक</div>
                            </td>
                        </div>
                        <td className="challanTable-centertext">{bankDetails.Account_Number}</td>
                    </tr>
                    <tr>
                        <td className="_normal">Payment Date
                            <div className='displayInGrid'>पेमेंट तारीख</div>
                        </td>
                        <td className="_normal">
                            <table style={{ width: '100%' }}>
                                <tbody>
                                    <tr>
                                        <td>DD</td>
                                        <td>MM</td>
                                        <td>YY</td>
                                    </tr>
                                    <tr style={{ height: '25px' }}>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td className="_normal">Transaction ID
                            <div className='displayInGrid'>व्यवहार आयडी</div>
                        </td>
                        <td className="_normal" rowSpan="2"></td>
                    </tr>
                    <tr>
                        <td className="_normal _12px">Bank Journal No. only Numeric
                            <div className='displayInGrid'>बँक जर्नल क्रमांक फक्त संख्यात्मक</div>
                        </td>
                    </tr>
                    <tr>
                        <td className="_normal">Application Fees
                            <div className='displayInGrid'>अर्ज फी</div>
                        </td>
                        <td className="challanTable-centertext">{personalData.Exam_Fee}</td>
                    </tr>
                    <tr>
                        <td className="_normal">Application ID
                            <div className='displayInGrid'>अर्ज आयडी</div>
                        </td>
                        <td className="challanTable-centertext">{personalData.Application_Id}</td>
                    </tr>
                    <tr>
                        <td className="_normal">Applicant Name
                            <div className='displayInGrid'>अर्जदाराचे नाव</div>
                        </td>
                        <td className="challanTable-centertext">{(personalData.First_Name || '') + ' ' + (personalData.Middle_Name || '') + ' ' + (personalData.Last_Name || '')}</td>
                    </tr>
                    <tr>
                        <td className="_normal _12px">Applicant Category
                            <div className='displayInGrid'>अर्जदाराची श्रेणी</div>
                        </td>
                        <td className="challanTable-centertext">{reservationDetails.Category}</td>
                    </tr>
                    <tr>
                        <td className="_normal">Branch Stamp
                            <div className='displayInGrid'>शाखेचा शिक्का</div>
                        </td>
                        
                        <td className="_normal"></td>
                    </tr>
                    <tr>
                    </tr>
                    <tr>
                        <td className="_normal _bold" colSpan="2">Note: </td>
                    </tr>
                    <tr>
                        <td className="_11px _bold _height50Px toptext" colSpan="2">{note}</td>
                    </tr>
                </tbody>
            </table>
        </>
    );
};

export default Challan;